import { render } from "./Rate.vue?vue&type=template&id=cceac2fc&scoped=true"
import script from "./Rate.vue?vue&type=script&lang=js"
export * from "./Rate.vue?vue&type=script&lang=js"

import "./Rate.vue?vue&type=style&index=0&id=cceac2fc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cceac2fc"]])

export default __exports__